module.exports = __webpack_public_path__ + "img/gadgets.4eae3fe2.svg";